module.exports = __webpack_public_path__ + "static/media/link.a38654f3.png";